import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function WarrantySection() {
  return <section className="bg-brand-light p-8 rounded-xl border border-gray-200" data-id="element-1055">
      <div className="flex items-start mb-6" data-id="element-1056">
        <ShieldCheck className="h-8 w-8 text-brand-yellow mr-4 mt-1" data-id="element-1057" />
        <div data-id="element-1058">
          <h2 className="text-2xl font-bold text-brand-dark mb-4" data-id="element-1059">
            Limited Warranty
          </h2>
          <div className="prose text-gray-600" data-id="element-1060">
            <p className="mb-4" data-id="element-1061">
              Precision Pro Sprayers warrants its ForceX products to be free
              from defects in material and workmanship for a period of one (1)
              year from the date of original purchase.
            </p>
            <p className="mb-4" data-id="element-1062">
              This warranty covers the pump, motor, and housing. Wear items such
              as hoses, seals, and nozzles are covered for 90 days against
              manufacturing defects.
            </p>
            <p data-id="element-1063">
              <strong data-id="element-1064">Exclusions:</strong> Damage caused by misuse, abuse,
              neglect, alterations, or use with incompatible chemicals is not
              covered.
            </p>
          </div>
        </div>
      </div>
    </section>;
}